function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withPropsOnChange from 'recompose/withPropsOnChange';
import pure from 'recompose/pure';
import setDisplayName from 'recompose/setDisplayName';
import { themePropType } from '@nivo/core';
import { LegendPropShape, BoxLegendSvg } from '@nivo/legends';
import { arcPropType } from './props';

class PieLegends extends Component {
  render() {
    const _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          legends = _this$props.legends,
          data = _this$props.data,
          theme = _this$props.theme;
    return legends.map((legend, i) => React.createElement(BoxLegendSvg, _extends({
      key: i
    }, legend, {
      containerWidth: width,
      containerHeight: height,
      data: data,
      theme: theme
    })));
  }

}

PieLegends.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  arcs: PropTypes.arrayOf(arcPropType).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  legends: PropTypes.arrayOf(PropTypes.shape(LegendPropShape)).isRequired,
  theme: themePropType.isRequired
} : {};
export const enhance = Component => compose(withPropsOnChange(['arcs'], ({
  arcs
}) => ({
  data: arcs.map(arc => ({
    id: arc.data.id,
    label: arc.data.id,
    color: arc.color,
    fill: arc.fill
  }))
})), pure)(Component);
export default setDisplayName('PieLegends')(enhance(PieLegends));